/** @jsx jsx */
import React, { useState, useCallback } from 'react';
import { Box, Flex, Container, Text, jsx } from 'theme-ui';

import { TextF5 } from '../text-f5';
import { Grid, Row, Col, Stack } from '../grid';
import { FeatureRow } from './feature-row';
import { Dropdown, DropdownItem, DropdownGroup, DropdownLabel } from '../dropdown';

export const TypefaceFeatures = ({ data, families }) => {
  const [font, setFont] = useState(data.font);
  const [familyName, setFamily] = useState(families[0].nameShort);

  const isSingle = families.length === 1 && families[0].fonts.length === 1;

  const onChangeFont = useCallback(
    ({ family, font }) => {
      setFont(font);
      setFamily(family);
    },
    [setFont]
  );
  return (
    <Container
      sx={{
        borderBottom: 'line',
        borderColor: 'line',
      }}
    >
      <Row>
        <Stack variant="0">
          <Flex
            sx={{
              position: 'relative',
              flexDirection: ['row', 'row'],
              flex: 0,
              width: '100%',
              mb: [5, 0],
              alignItems: ['center', 'center'],
            }}
          >
            <Box
              sx={{
                flex: 1,
              }}
            >
              <Text as="h4" variant="section_header">
                Opentype <div sx={{ display: ['block', 'none'] }} />
                Features
              </Text>
            </Box>

            <Box
              sx={{
                display: isSingle ? 'none' : 'block',
                flex: '0 1 auto',
                position: ['absolute', 'absolute'],
                right: ['0', 0],
              }}
            >
              <Dropdown trigger={`${familyName} ${font.name}`} outline={false}>
                {families.map((family) => (
                  <DropdownGroup key={family._id}>
                    {family.fonts.map((style) => {
                      let fontLabel = `${family.nameShort} ${style.name}`;
                      if (
                        ['normal', 'regular', '-'].includes(family.nameShort.trim().toLowerCase())
                      ) {
                        fontLabel = `${style.name}`;
                      }
                      return (
                        <DropdownItem
                          value={{ family: family.nameShort, font: style }}
                          align="end"
                          onSelect={onChangeFont}
                          key={style._id}
                        >
                          <TextF5 variant="tester.fontStyle" font={style._id}>
                            {fontLabel}
                          </TextF5>
                        </DropdownItem>
                      );
                    })}
                  </DropdownGroup>
                ))}
              </Dropdown>
            </Box>
          </Flex>

          <Grid columns={[1, 2]} as="ul" gap={[7, 8, 8, 9, 10]} gapY={[7, 8, 8, 9, 10]}>
            {data.rows.map((row) => (
              <Col key={row._key} sx={{ display: 'flex' }} as="li">
                <FeatureRow font={font} {...row} />
              </Col>
            ))}
          </Grid>
        </Stack>
      </Row>
    </Container>
  );
};
